export default "__VITE_ASSET__DVqg_rzw__"